import React, { useState, useEffect } from 'react';
import styles from './CharityButtons.module.css';
import HeartIcon from './HeartIcon';
import Modal from '../Modal';
import { useAppConfig } from '../../context/AppConfigContext';
import { applySiteBranding } from '../../config/siteConfig';
import { Capacitor } from '@capacitor/core';
// import { InAppReview } from '@capacitor-community/in-app-review';

const translations = {
  ru: {
    charity: {
      title: "Поддержка проекта",
      tabs: {
        review: "Оставить отзыв",
        donate: "Сделать вклад"
      },
      reviewText:
        "Если вам нравится BlaBlaLingo, оставьте, пожалуйста, отзыв — это очень поможет нам в развитии и продвижении приложения!",
      donateText:
        "Вы можете финансово поддержать проект BlaBlaLingo. Это поможет нам развивать новые функции, оплачивать серверы и делать приложение доступным для всех. Спасибо за вашу поддержку!",
      tonLabel: "TON или USDT",
      usdtLabel: "USDT",
      starsLabel: "Звёзды Telegram",
      alertMessage:
        "Нажав OK, вы перейдёте в Telegram-бота, где сможете поддержать нас, отправив любое количество звёзд ⭐",
      copy: "Скопировать",
      close: "Закрыть",
      copySuccess: "Скопировано!",
      communityTitle: "Информация и комьюнити BlaBlaLingo",
      communityText:
        "Присоединяйтесь к нашему Telegram: новости, объяснения, вопросы и идеи. Помогите нам сделать BlaBlaLingo лучше 🚀",
      communityButton: "Перейти в Telegram"
	  
    }
  },
  uk: {
    charity: {
      title: "Підтримка проєкту",
      tabs: {
        review: "Залишити відгук",
        donate: "Зробити внесок"
      },
      reviewText:
        "Якщо вам подобається BlaBlaLingo, будь ласка, залиште відгук — це дуже допоможе нам у розвитку та просуванні застосунку!",
      donateText:
        "Ви можете фінансово підтримати проєкт BlaBlaLingo. Це допоможе нам розвивати нові функції, оплачувати сервери та робити застосунок доступним для всіх. Дякуємо за підтримку!",
      tonLabel: "TON або USDT",
      usdtLabel: "USDT",
      starsLabel: "Зірки Telegram",
      alertMessage:
        "Натиснувши OK, ви перейдете до Telegram-бота, де зможете підтримати нас, надіславши будь-яку кількість зірок ⭐",
      copy: "Скопіювати",
      close: "Закрити",
      copySuccess: "Скопійовано!",

      // 🆕 текст для комьюнити
      communityTitle: "Інформація та комʼюніті BlaBlaLingo",
      communityText:
        "Приєднуйтесь до нашого Telegram, ставте запитання, діліться досвідом та допоможіть нам зробити BlaBlaLingo кращим 🚀",
      communityButton: "Перейти в Telegram"
    }
  },  
  en: {
    charity: {
      title: "Support the Project",
      tabs: {
        review: "Leave a Review",
        donate: "Contribute"
      },
      reviewText:
        "If you enjoy using BlaBlaLingo, please leave a review — it helps us grow and reach more people!",
      donateText:
        "You can support the BlaBlaLingo project financially. Your contribution helps us develop new features, cover server costs, and keep the app free for everyone. Thank you!",
      tonLabel: "TON or USDT",
      usdtLabel: "USDT",
      starsLabel: "Telegram Stars",
      alertMessage:
        "By clicking OK, you'll be redirected to a Telegram bot where you can support us with any number of stars ⭐",
      copy: "Copy",
      close: "Close",
      copySuccess: "Copied!"
    }
  },
  de: {
    charity: {
      title: "Projekt unterstützen",
      tabs: {
        review: "Bewertung schreiben",
        donate: "Beitragen"
      },
      reviewText:
        "Wenn dir BlaBlaLingo gefällt, hinterlasse bitte eine Bewertung – das hilft uns sehr bei der Weiterentwicklung und Verbreitung!",
      donateText:
        "Du kannst das BlaBlaLingo-Projekt finanziell unterstützen. Damit hilfst du uns, neue Funktionen zu entwickeln, Serverkosten zu decken und die App für alle zugänglich zu halten. Vielen Dank!",
      tonLabel: "TON oder USDT",
      usdtLabel: "USDT",
      starsLabel: "Telegram-Sterne",
      alertMessage:
        "Wenn du auf OK klickst, wirst du zu einem Telegram-Bot weitergeleitet, wo du uns mit beliebig vielen Sternen ⭐ unterstützen kannst",
      copy: "Kopieren",
      close: "Schließen",
      copySuccess: "Kopiert!"
    }
  }
};

export default function CharityButtons() {
  //const { t } = useAppConfig();
  const {
    baseLanguage,
    playStoreUrl,
    playStorePackageName,
    trustpilotUrl,
    tonWallet,
    telegramCommunityUrl,
  } = useAppConfig();
  const locale = translations[baseLanguage] ? baseLanguage : 'en';
  const t = applySiteBranding(translations[locale] || translations.en);
  const [showModal, setShowModal] = useState(false);
  const [showExternModal, setShowExternModal] = useState(false);
  const [activeTab, setActiveTab] = useState('review');
  const [copySuccess, setCopySuccess] = useState('');

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopySuccess(t.charity.copySuccess);
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      console.error('Copy failed', err);
    }
  };
  
	const handleClose = () => {
	  window.location.href = telegramCommunityUrl;
	};

	const CustomPlayStore = {
	  openPlayStore: (options = {}) => {
		return Capacitor.isNativePlatform() 
		  ? Capacitor.Plugins.CustomPlayStore.openPlayStore(options)
		  : Promise.resolve({ success: false, error: 'Not native platform' });
	  },
	  
	  shareApp: (options = {}) => {
		return Capacitor.isNativePlatform()
		  ? Capacitor.Plugins.CustomPlayStore.shareApp(options)
		  : Promise.resolve({ success: false, error: 'Not native platform' });
	  }
	};
	
	const showCommunityBlock = locale === 'ru' || locale === 'uk';

	// Использование:
	const requestReview = async () => {
	  if (!Capacitor.isNativePlatform()) {
		window.open(playStoreUrl, '_blank');
		return;
	  }

	  try {
		const result = await CustomPlayStore.openPlayStore({
		  packageName: playStorePackageName
		});
	  } catch (error) {
		// Fallback
		window.open(playStoreUrl, '_blank');
	  }
	};
  return (
    <>
      <button
        className={`${styles.charityButtonsContainer} ${styles.circleButton} ${styles.pulsing}`}
        onClick={() => setShowModal(true)}
      >
        <HeartIcon />
      </button>

      {showModal && (
        <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
            <div className={styles.tabs}>
              <button
                className={`${styles.tabButton} ${activeTab === 'review' ? styles.activeTab : ''}`}
                onClick={() => setActiveTab('review')}
              >
                {t.charity.tabs.review}
              </button>
			  {/*
              <button
                className={`${styles.tabButton} ${activeTab === 'donate' ? styles.activeTab : ''}`}
                onClick={() => setActiveTab('donate')}
              >
                {t.charity.tabs.donate}
              </button>
			  */}
            </div>

			{activeTab === 'review' && (
			  <div className={styles.tabContent}>

				{showCommunityBlock && (
				  <div className={styles.communityBlock}>
					<h4>{t.charity.communityTitle}</h4>
					<p>{t.charity.communityText}</p>
					<a
					  href={telegramCommunityUrl}
					  target="_blank"
					  rel="noopener noreferrer"
					  className={styles.communityBtn}
					>
					  {t.charity.communityButton}
					</a>
				  </div>
				)}

				<p>{t.charity.reviewText}</p>

				<div className={styles.reviewButtons}>
				  <button className={styles.reviewBtn} onClick={requestReview}>
					Google Play
				  </button>
				  <a
					href={trustpilotUrl}
					target="_blank"
					className={styles.reviewBtn}
				  >
					Trustpilot
				  </a>
				</div>
			  </div>
			)}

            {/*activeTab === 'donate' && (
              <div className={styles.tabContent}>
                <p>{t.charity.donateText}</p>
                <div className={styles.donateOptions}>
                  <div className={styles.cryptoRow}>
					<span onClick={() => handleCopy(tonWallet)} >{t.charity.tonLabel}: {tonWallet}</span>
                  </div>
				  <button className={styles.donateBtn} onClick={() => setShowExternModal(true)} >{t.charity.starsLabel}</button>
                  {copySuccess && <div className={styles.copySuccess}>{copySuccess}</div>}
                </div>
              </div>
            )*/}
			
			{showExternModal && (
			  <Modal
				title={t.charity.starsLabel}
				onConfirm={() => { 
				  setShowExternModal(false); 
				  handleClose();       // запускаем телеграм-бота
				}}
				onClose={() => setShowExternModal(false)} // закрытие без перехода
			  >
				<p>{t.charity.alertMessage}</p>
			  </Modal>
			)}
			

            <button className={styles.closeBtn} onClick={() => setShowModal(false)}>
              {t.charity.close}
            </button>
          </div>
        </div>
      )}
    </>
  );
}




	/* - альтернативное решение без плагина
	const requestReview = async () => {
	  if (!Capacitor.isNativePlatform()) {
		window.open('https://play.google.com/store/apps/details?id=com.blablalingo.app', '_blank');
		return;
	  }

	  // Используем нативный способ через window.open
	  try {
		// Пытаемся открыть в Google Play приложении
		window.open('market://details?id=com.blablalingo.app', '_self');
		
		// Fallback через setTimeout, если market:// не сработал
		setTimeout(() => {
		  window.open('https://play.google.com/store/apps/details?id=com.blablalingo.app', '_blank');
		}, 1000);
		
	  } catch (error) {
		window.open('https://play.google.com/store/apps/details?id=com.blablalingo.app', '_blank');
	  }
	};
	*/
